<div class="warning__box" [ngClass]="class">
    <div class="warning__icon" *ngIf="icon !== 'null'">
        <span class="material-symbols-outlined">
            {{icon}}
        </span>
    </div>
    <div *ngIf="!values" class="warning__text" [innerHTML]="text | translate"></div>
    <div *ngIf="values" class="warning__text" [innerHTML]="text | translate : values "></div>
</div>